const formatLabel = (daysRemaining) => {
  if (daysRemaining >= 360) {
    const totalMonths = Math.round(daysRemaining / 30);
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    if (months === 0) {
      return `${Math.max(years, 1)}a`;
    }
    return `${Math.max(years, 1)}a ${months}m`;
  }
  if (daysRemaining >= 60) {
    const months = Math.floor(daysRemaining / 30);
    return `${months}m`;
  }
  return `${daysRemaining}d`;
};

const getColor = (ratio) => {
  if (ratio > 0.5) return "#27ae60";
  if (ratio > 0.2) return "#f2994a";
  return "#eb5757";
};

const CircularProgress = ({ daysRemaining, totalDays }) => {
  const size = 48;
  const strokeWidth = 4;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const ratio = totalDays > 0 ? Math.max(0, Math.min(1, daysRemaining / totalDays)) : 0;
  const offset = circumference * (1 - ratio);
  const color = getColor(ratio);
  const label = formatLabel(daysRemaining);

  return (
    <div className="gm-circular-progress" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="gm-circular-progress__bg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className="gm-circular-progress__fg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={color}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="gm-circular-progress__label" style={{ color }}>
        {label}
      </span>
    </div>
  );
};

export default CircularProgress;
